module.exports = __webpack_public_path__ + "static/media/chart.aa03db8d.png";